import React from 'react';
import moment from 'moment';
import { DateFormats } from 'constants/common';
import { Stack, Typography } from '@mui/material';

import { DealSheetRulesTableRow } from '../../types';

interface Props {
  rule: DealSheetRulesTableRow;
}

export const RuleName = ({ rule }: Props) => (
  <Stack>
    <Typography>{rule.name}</Typography>

    <Typography variant="body2" color="textDisabled">
      {moment(rule.createdDateTime).format(DateFormats.DateTimeMedium24Hour)}
    </Typography>
  </Stack>
);
